export const HighlightText = (text, search) => {
  if (!search) return text;

  // Escape special regex characters
  const escapedSearch = search.replaceAll(/[-/\\^$*+?.()|[\]{}]/g, match => String.raw`\${match}`);
  // Create a regex that matches the whole search string, including spaces
  const regex = new RegExp(`(${escapedSearch})`, 'gi');
  const parts = String(text).split(regex);

  return parts.map((part, i) =>
    part.toLowerCase() === search.toLowerCase() ? (
      <mark key={`${part}-${i}`} style={{ backgroundColor: '#FFCE2E4D', padding: 0 }}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};

  